(function () {
  const MAKE_ALIASES = {
    ford: 'ford',
    f250: 'ford',
    f350: 'ford',
    f450: 'ford',
    f550: 'ford',
    superduty: 'ford',
    fordsuperduty: 'ford',
    powerstroke: 'ford',
    gm: 'gm',
    gmc: 'gm',
    chevy: 'gm',
    chevrolet: 'gm',
    silverado: 'gm',
    chevysilverado: 'gm',
    chevroletsilverado: 'gm',
    sierra: 'gm',
    gmcsierra: 'gm',
    duramax: 'gm',
    colorado: 'gm',
    canyon: 'gm',
    chevycolorado: 'gm',
    gmccanyon: 'gm',
    ram: 'ram',
    dodge: 'ram',
    dodgeram: 'ram',
    cummins: 'ram',
    ram1500: 'ram',
    ram2500: 'ram',
    ram3500: 'ram',
    ram4500: 'ram',
    ram5500: 'ram',
    dodge2500: 'ram',
    dodge3500: 'ram',
    ramecodiesel: 'ram',
    ramcummins: 'ram',
    dodgecummins: 'ram',
    jeep: 'jeep',
    cherokee: 'jeep',
    grandcherokee: 'jeep',
    jeepcherokee: 'jeep',
    jeepgrandcherokee: 'jeep',
    gladiator: 'jeep',
    wrangler: 'jeep',
    jeepgladiator: 'jeep',
    jeepwrangler: 'jeep',
    jeepecodiesel: 'jeep',
    benz: 'benz',
    mercedes: 'benz',
    mercedesbenz: 'benz',
    sprinter: 'benz',
    mercedessprinter: 'benz',
    mercedesbenzsprinter: 'benz',
    nissan: 'nissan',
    titan: 'nissan',
    titanxd: 'nissan',
    nissantitan: 'nissan',
    nissantitanxd: 'nissan',
  };

  const MAKE_LABELS = {
    ford: 'Ford',
    gm: 'GM',
    ram: 'Ram',
    jeep: 'Jeep',
    benz: 'Mercedes Benz',
    nissan: 'Nissan',
  };

  const BODY_ALIASES = {
    all: 'all',
    any: 'all',
    pickup: 'pickup',
    truck: 'pickup',
    cc: 'CC',
    van: 'van',
  };

  const BODY_LABELS = {
    all: 'All body styles',
    pickup: 'Pickup',
    CC: 'Cab & Chassis',
    van: 'Van',
  };

  const GM_ENGINE_CODES = new Set(['LB7', 'LLY', 'LBZ', 'LMM', 'LML', 'L5P', 'L5D', 'LWN', 'LM2', 'LZ0']);
  const BUNDLE_BUILDER_PATH = '/pages/bundle-builder';
  const BUNDLE_DISCOUNT_CODE = 'CUSTOM_BUNDLE';
  const BUNDLE_DISCOUNT_PERCENT = 5;
  const BUNDLE_DISCOUNT_REQUIRED_STEPS = ['tuner', 'egr', 'exhaust'];

  function normalizeKey(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[&]/g, ' and ')
      .replace(/[_./]+/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function compactKey(value) {
    return normalizeKey(value).replace(/\s+/g, '');
  }

  function parseYear(year) {
    const parsed = Number.parseInt(String(year ?? '').trim(), 10);
    if (!Number.isFinite(parsed) || parsed < 1999 || parsed > 2026) {
      return { error: 'year must be a model year between 1999 and 2026.' };
    }
    return { year: String(parsed) };
  }

  function parseMake(make) {
    const compact = compactKey(make);
    if (!compact) return { error: 'make is required (ford, gm, ram, jeep, benz, or nissan).' };

    const aliased = MAKE_ALIASES[compact];
    if (aliased) return { make: aliased };

    if (compact.includes('mercedes') || compact.includes('sprinter')) return { make: 'benz' };
    if (compact.includes('dodge') || compact.includes('ram')) return { make: 'ram' };
    if (
      compact.includes('chevy') ||
      compact.includes('chevrolet') ||
      compact.includes('duramax') ||
      compact.includes('sierra') ||
      compact.includes('silverado') ||
      compact.includes('colorado') ||
      compact.includes('canyon')
    ) {
      return { make: 'gm' };
    }
    if (compact.includes('ford') || compact.includes('powerstroke') || compact.includes('superduty')) {
      return { make: 'ford' };
    }
    if (
      compact.includes('jeep') ||
      compact.includes('gladiator') ||
      compact.includes('wrangler') ||
      compact.includes('cherokee')
    ) {
      return { make: 'jeep' };
    }
    if (compact.includes('nissan') || compact.includes('titan')) return { make: 'nissan' };

    return {
      error:
        'Unrecognized make. Use ford, gm, ram, jeep, benz, or nissan (Chevy/GMC map to gm, Dodge maps to ram).',
    };
  }

  function parseEngine(engine) {
    const raw = String(engine || '').trim();
    if (!raw) {
      return {
        error:
          'engine is required. Use a displacement like 6.7L / 6-7L, or a GM code like L5P or LML.',
      };
    }

    const upper = raw.toUpperCase();
    const codeMatch = upper.match(/\b(L5P|L5D|LB7|LLY|LBZ|LMM|LML|LWN|LM2|LZ0)\b/);
    if (codeMatch) return { engine: codeMatch[1] };

    const displacementMatch = upper.replace(/\s+/g, '').match(/(\d)[.-]?(\d)\s*L/);
    if (displacementMatch) {
      return { engine: `${displacementMatch[1]}-${displacementMatch[2]}L` };
    }

    const alreadyStored = raw.match(/^(\d)-(\d)L$/i);
    if (alreadyStored) return { engine: `${alreadyStored[1]}-${alreadyStored[2]}L` };

    if (GM_ENGINE_CODES.has(upper)) return { engine: upper };

    return {
      error:
        'Unrecognized engine. Use 6.7L, 6-7L, 6.0L, 3.0L, or a GM Duramax code such as L5P or LML.',
    };
  }

  function parseBody(body) {
    if (body == null || String(body).trim() === '') return { body: 'all' };

    const normalized = normalizeKey(body);
    const compact = compactKey(body);

    if (BODY_ALIASES[normalized] || BODY_ALIASES[compact]) {
      return { body: BODY_ALIASES[normalized] || BODY_ALIASES[compact] };
    }

    if (normalized.includes('cab') && normalized.includes('chassis')) return { body: 'CC' };
    if (normalized.includes('pickup')) return { body: 'pickup' };
    if (normalized === 'c and c' || compact === 'c&c' || compact === 'candc') return { body: 'CC' };
    if (normalized.includes('van')) return { body: 'van' };
    if (normalized.includes('all')) return { body: 'all' };

    return { error: 'Unrecognized body. Use all, pickup, CC (cab & chassis), or van.' };
  }

  function parseVehicleInput({ year, make, engine, body } = {}) {
    const parsedYear = parseYear(year);
    if (parsedYear.error) return parsedYear;

    const parsedMake = parseMake(make);
    if (parsedMake.error) return parsedMake;

    const parsedEngine = parseEngine(engine);
    if (parsedEngine.error) return parsedEngine;

    const parsedBody = parseBody(body);
    if (parsedBody.error) return parsedBody;

    return {
      year: parsedYear.year,
      make: parsedMake.make,
      engine: parsedEngine.engine,
      body: parsedBody.body,
    };
  }

  function formatVehicle(vehicle) {
    if (!vehicle?.make) return null;

    const engineDisplay =
      window.TdVehicleStorage?.formatEngineDisplay(vehicle.engine) ||
      String(vehicle.engine || '').replace(/-/g, '.');
    const makeLabel = MAKE_LABELS[vehicle.make] || vehicle.make;
    const bodyLabel = BODY_LABELS[vehicle.body] || vehicle.body || 'All body styles';

    return {
      year: vehicle.year,
      make: vehicle.make,
      engine: vehicle.engine,
      engineDisplay,
      body: vehicle.body || 'all',
      label: `${vehicle.year} ${makeLabel} ${engineDisplay}`.trim(),
      bodyLabel,
    };
  }

  function getStorageError() {
    if (window.TdVehicleStorage?.getSelectedVehicle && window.TdVehicleStorage?.addVehicle) {
      return null;
    }
    return { error: 'Vehicle storage is not available on this page.' };
  }

  function isBundleWizardAvailable() {
    return typeof window.TdBundleBuilder?.getState === 'function';
  }

  function getCustomKitInfo() {
    const vehicle = formatVehicle(window.TdVehicleStorage?.getSelectedVehicle?.());
    const onBuilderPage = isBundleWizardAvailable();

    return {
      available: true,
      name: 'Custom Kit Builder',
      url: BUNDLE_BUILDER_PATH,
      onBuilderPage,
      vehicle: vehicle || null,
      discount: {
        code: BUNDLE_DISCOUNT_CODE,
        percent: BUNDLE_DISCOUNT_PERCENT,
        requiredSteps: BUNDLE_DISCOUNT_REQUIRED_STEPS,
        note: 'Discount applies only when tuner, EGR, and exhaust are all selected (not skipped).',
      },
      builds:
        'Vehicle-specific custom kit: tuner, EGR, exhaust, pipes, intake, and extras. Do not assemble a kit with search_catalog or update_cart.',
      wizardTools: onBuilderPage
        ? ['get_bundle_state', 'choose_bundle_option', 'skip_bundle_step', 'add_bundle_to_cart']
        : [],
      howTo: onBuilderPage
        ? [
            'This page is the kit wizard.',
            'If no vehicle is selected, call set_shopper_vehicle.',
            'Call get_bundle_state, then choose_bundle_option or skip_bundle_step, then add_bundle_to_cart.',
          ]
        : [
            'If no vehicle is selected, call set_shopper_vehicle first (it persists across pages).',
            `Open ${BUNDLE_BUILDER_PATH}. Wizard tools are not registered on this page.`,
            'After that page loads, call get_bundle_state, then choose_bundle_option or skip_bundle_step, then add_bundle_to_cart.',
          ],
      message: onBuilderPage
        ? 'You are on the custom kit builder. Use get_bundle_state to start.'
        : `Custom kits are built at ${BUNDLE_BUILDER_PATH}. Open that URL, then use get_bundle_state. Do not use search_catalog or update_cart to assemble a kit.`,
    };
  }

  async function registerVehicleTools(modelContext) {
    await modelContext.registerTool({
      name: 'get_shopper_vehicle',
      description:
        "Return the truck this shopper selected (year, make, engine, body). Call this before recommending parts or starting a custom kit. If no vehicle is selected, use set_shopper_vehicle first. For a full custom kit (tuner, EGR, exhaust), call get_custom_kit_info — do not assemble a kit with search_catalog or update_cart.",
      inputSchema: { type: 'object', properties: {} },
      annotations: { readOnlyHint: true },
      execute: async () => {
        const storageError = getStorageError();
        if (storageError) return storageError;

        const vehicle = formatVehicle(window.TdVehicleStorage.getSelectedVehicle());
        if (!vehicle) {
          return {
            selected: false,
            message: 'No vehicle selected. Use set_shopper_vehicle first.',
          };
        }

        return { selected: true, vehicle };
      },
    });

    await modelContext.registerTool({
      name: 'set_shopper_vehicle',
      description:
        "Save the shopper's truck and refresh fitment (parts grid, kit builder, product badges). Use this when they name a year/make/engine. Prefer this over search_catalog for vehicle fitment. For GM Duramax, prefer an engine code (L5P, LML) over a displacement. After saving, call get_custom_kit_info if they want a custom kit.",
      inputSchema: {
        type: 'object',
        properties: {
          year: { type: 'number', description: 'Model year, e.g. 2015' },
          make: {
            type: 'string',
            description: 'ford, gm, ram, jeep, benz, or nissan. Ford/Chevy/Dodge/GMC also OK.',
          },
          engine: {
            type: 'string',
            description: 'Displacement such as 6.7L or 6-7L, or a GM code such as L5P or LML.',
          },
          body: {
            type: 'string',
            description: 'all, pickup, CC, or van. Defaults to all.',
          },
        },
        required: ['year', 'make', 'engine'],
      },
      execute: async (args) => {
        const storageError = getStorageError();
        if (storageError) return storageError;

        const parsed = parseVehicleInput(args || {});
        if (parsed.error) return parsed;

        const vehicle = formatVehicle(window.TdVehicleStorage.addVehicle(parsed));
        const onBuilderPage = isBundleWizardAvailable();
        const bundleMatches = onBuilderPage
          ? window.TdBundleBuilder?.resolveVehicleConfig?.(parsed) || []
          : [];

        return {
          ok: true,
          vehicle,
          bundleSupported: bundleMatches.length > 0,
          kitBuilderUrl: BUNDLE_BUILDER_PATH,
          onBuilderPage,
          message: onBuilderPage
            ? 'Vehicle saved. Call get_bundle_state to start the custom kit.'
            : `Vehicle saved. For a custom kit (tuner, EGR, exhaust), open ${BUNDLE_BUILDER_PATH} or call get_custom_kit_info.`,
        };
      },
    });
  }

  async function registerKitPointerTool(modelContext) {
    await modelContext.registerTool({
      name: 'get_custom_kit_info',
      description:
        'Explain how to build a custom delete kit (tuner, EGR, exhaust, pipes) for the selected truck. Available on every page. Returns the bundle builder URL. On other pages, send the shopper to that URL — wizard tools (get_bundle_state, choose_bundle_option, skip_bundle_step, add_bundle_to_cart) only exist after it loads. Do not assemble a kit with search_catalog or update_cart.',
      inputSchema: { type: 'object', properties: {} },
      annotations: { readOnlyHint: true },
      execute: async () => getCustomKitInfo(),
    });
  }

  async function registerBundleTools(modelContext) {
    const builder = window.TdBundleBuilder;

    await modelContext.registerTool({
      name: 'get_bundle_state',
      description:
        'Return the current custom-kit wizard: selected vehicle, phase, current step, visible options, temp cart, and whether the 5% CUSTOM_BUNDLE discount applies (tuner + egr + exhaust). Call this after set_shopper_vehicle and after every choose_bundle_option or skip_bundle_step. Use only on the bundle builder page. Do not use search_catalog or update_cart to assemble a kit.',
      inputSchema: { type: 'object', properties: {} },
      annotations: { readOnlyHint: true },
      execute: async () => builder.getState(),
    });

    await modelContext.registerTool({
      name: 'choose_bundle_option',
      description:
        'Select an option on the current custom-kit step and advance the wizard. Use step_key and option_id from get_bundle_state currentStep. The shopper will see the builder update. If phase is vehicle_config, pick the year range that matches the truck.',
      inputSchema: {
        type: 'object',
        properties: {
          step_key: {
            type: 'string',
            description: 'Current step key from get_bundle_state, e.g. tuner, egr, exhaust, vehicle_config.',
          },
          option_id: {
            type: 'string',
            description: 'Option id from currentStep.options.',
          },
        },
        required: ['step_key', 'option_id'],
      },
      execute: async (args) =>
        builder.chooseOption(args?.step_key, args?.option_id),
    });

    await modelContext.registerTool({
      name: 'skip_bundle_step',
      description:
        'Skip the current custom-kit step. For tuner, egr, or exhaust, skipping makes an incomplete delete kit: first call returns a warning unless confirm_incomplete is true. Use step_key from get_bundle_state.',
      inputSchema: {
        type: 'object',
        properties: {
          step_key: {
            type: 'string',
            description: 'Current step key from get_bundle_state.',
          },
          confirm_incomplete: {
            type: 'boolean',
            description: 'Set true to skip tuner, egr, or exhaust after the shopper accepts an incomplete kit.',
          },
        },
        required: ['step_key'],
      },
      execute: async (args) =>
        builder.skipCurrentStep(args?.step_key, Boolean(args?.confirm_incomplete)),
    });

    await modelContext.registerTool({
      name: 'add_bundle_to_cart',
      description:
        'Add the finished custom kit to the cart with bundle line properties and CUSTOM_BUNDLE when tuner, egr, and exhaust are all selected. Do not use update_cart to assemble a kit.',
      inputSchema: { type: 'object', properties: {} },
      execute: async () => builder.addCurrentBuildToCart(),
    });
  }

  async function registerYmeTools(modelContext) {
    const ymeResults = window.TdYmeResults;

    await modelContext.registerTool({
      name: 'search_parts_for_vehicle',
      description:
        'Search parts that fit the selected truck using store year/make/engine fitment data. Do not use search_catalog for vehicle fitment. Optional product_type examples: Tuner, EGR, Race Exhaust, Cold Air Intake. If the shopper wants a full custom kit, call get_custom_kit_info and send them to /pages/bundle-builder instead of adding random SKUs.',
      inputSchema: {
        type: 'object',
        properties: {
          product_type: {
            type: 'string',
            description: 'Optional product type filter, e.g. Tuner, EGR, Race Exhaust.',
          },
          query: {
            type: 'string',
            description: 'Optional text to match in product title, type, vendor, or tags.',
          },
          limit: {
            type: 'number',
            description: 'Max products to return (default 12, max 50).',
          },
        },
      },
      annotations: { readOnlyHint: true },
      execute: async (args) =>
        ymeResults.getMatchingProducts({
          productType: args?.product_type,
          query: args?.query,
          limit: args?.limit,
        }),
    });
  }

  async function registerTdWebMcpTools() {
    const modelContext = document.modelContext;
    if (!modelContext || typeof modelContext.registerTool !== 'function') {
      return;
    }

    await registerVehicleTools(modelContext);
    await registerKitPointerTool(modelContext);

    if (isBundleWizardAvailable()) {
      await registerBundleTools(modelContext);
    }

    if (window.TdYmeResults?.getMatchingProducts) {
      await registerYmeTools(modelContext);
    }
  }

  if (document.readyState === 'complete') {
    registerTdWebMcpTools();
  } else {
    document.addEventListener('DOMContentLoaded', registerTdWebMcpTools);
  }
})();
